export default __webpack_public_path__ + "static/media/stat-17-papers.31c2fbc6.svg";